import { useEffect, useRef, useState } from "react";
import PageLayout from "../components/PageLayout";
import IconComponent from "../components/Icon";
import { FaChevronDown, FaStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import LoaderFull from "../components/LoaderFull";
import axiosInstance from "../api/apiClient";
import { FiX } from "react-icons/fi";
const noCover = 'https://dryofg8nmyqjw.cloudfront.net/images/no-cover.png'

const AddBook = () => {
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const [ISBN, setISBN] = useState<string>(params.get('isbn') || '');

    const [series, setSeries] = useState<any[]>([]);
    const [genres, setGenres] = useState<any[]>([]);

    const [genreIsOpen, setGenreIsOpen] = useState(false);

    const genreRef = useRef<HTMLDivElement>(null);

    const [allBooks, setAllBooks] = useState<any>([]);
    const [showBookInfo, setShowBookInfo] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [newBook, setNewBook] = useState<any>({
        "Book Id": null,
        "Title": null,
        "Author": null,
        "Author l-f": null,
        "Additional Authors": null,
        "ISBN": null,
        "ISBN13": null,
        "My Rating": null,
        "Average Rating": null,
        "Publisher": null,
        "Binding": null,
        "Number of Pages": null,
        "Year Published": null,
        "Original Publication Year": null,
        "Date Read": null,
        "Date Added": new Date(),
        "Bookshelves": '',
        // "Bookshelves with positions": null,
        "Exclusive Shelf": null,
        "My Review": null,
        "Genres": [],
        "Serie Id": null,
        "Serie Position": null,
    });

  const addBook = async () => {
    setLoading(true);
  
    try {
      // Stap 1: Boek toevoegen
      await axiosInstance.post('/addBook', newBook);
  
      // Stap 2: Lijst opnieuw ophalen
      const updatedBooks = await getAllCurrentBooks();
  
      // Stap 3: Boek vinden in nieuwe lijst
      const addedBook = updatedBooks.find((book: { "Book Id": number }) => book["Book Id"] === newBook["Book Id"]);
  
      if (!addedBook) {
        console.error('Nieuw boek niet gevonden in de lijst.');
        setLoading(false);
        return;
      }
  
      // Stap 4: Navigeren nadat alles klaar is
      
    } catch (error) {
      console.error('Fout bij het toevoegen van boek:', error);
      setLoading(false);
    }

    setLoading(false);
    navigate(`/Book/${newBook["Book Id"]}`);
  };

  const getAllCurrentBooks = async () => {
    const response = await axiosInstance.get('/getAllBooks');
    const data:any = response
    setAllBooks(data);
    return data;
  };

  // Function to generate a unique ID for the new book
  const generateUniqueId = (): number => {
    const randomNumber = Math.floor(Math.random() * 9000000) + 1000000;
  
    const isDuplicate = allBooks.some((book: { "Book Id": number }) => book["Book Id"] === randomNumber);
  
    if (isDuplicate) {
      return generateUniqueId();
    } else {
      return randomNumber;
    }
  };

    const toggleSelection = (genre: { genre_id: string; name: string }) => {
        if (newBook['Genres'].includes(genre.genre_id)) {
            setNewBook({ ...newBook, 'Genres': newBook['Genres'].filter((g:any) => g !== genre.genre_id) });
        } else {
            setNewBook({ ...newBook, 'Genres': [...newBook['Genres'], genre.genre_id.toString()] });
        }
    };

    const removeGenre = (genre: string) => {
        setNewBook({ ...newBook, 'Genres': newBook['Genres'].filter((g:any) => g !== genre) });
    };

    const getSeries = async () => {
        const response: any = await axiosInstance.get('/getAllSeries');
        setSeries(response);
    }

    const getGenres = async () => {
        const response: any = await axiosInstance.get('/getAllGenres');
        const formatResponse = response.map((genre: { genre_id: number; name: string; }) => {
            return {
                genre_id: genre.genre_id.toString(),
                name: genre.name
            }
        }).sort((a: { name: string; }, b: { name: string; }) => a.name.localeCompare(b.name));
        setGenres(formatResponse);
    }

      const searchBook = async () => {
        const response = await fetch(`https://www.googleapis.com/books/v1/volumes?q=isbn:${ISBN}&quotaUser=biblo&key=${process.env.REACT_APP_GOOGLE_API_KEY}`).then((r) => r.json());
        if (response.totalItems === 0) {
            alert('Geen boek gevonden met deze ISBN nummer');
            return;
        }

        const bookData = {
            "Book Id": generateUniqueId(),
            "Title": response.items[0].volumeInfo.title || null,
            "Author": response.items[0].volumeInfo.authors?.[0] || null,
            "Author l-f": response.items[0].volumeInfo.authors?.[0].split(' ').reverse().join(', ') || null,
            "Additional Authors": "",
            "ISBN": response.items[0].volumeInfo.industryIdentifiers?.find((identifier: { type: string; }) => identifier.type === 'ISBN_10')?.identifier || null,
            "ISBN13": ISBN || null,
            "My Rating": null,
            "Average Rating": response.items[0].volumeInfo.averageRating || null,
            "Publisher": response.items[0].volumeInfo.publisher || null,
            "Binding": response.items[0].volumeInfo.printType || null,
            "Number of Pages": response.items[0].volumeInfo.pageCount || null,
            "Year Published": response.items[0].volumeInfo.publishedDate,
            "Original Publication Year": response.items[0].volumeInfo.publishedDate || null,
            "Date Read": null,
            "Date Added": new Date(),
            "Bookshelves": "",
            // "Bookshelves with positions": "",
            "Exclusive Shelf": "to-read",
            "My Review": "",
            "Spoiler": "",
            "Private Notes": "",
            "Read Count": 0,
            "Owned Copies": 0,
            "Genres": [],

            // TODO: Add the rest of the fields
            "Serie Id": null,
            "Serie Position": null,

        };

        if (allBooks.some((book: { "ISBN13": string }) => book["ISBN13"] === ISBN)) {
            navigate(`/book/${allBooks.find((book: { "ISBN13": string }) => book["ISBN13"] === ISBN)['Book Id']}`);
            return;
        }
        setNewBook(bookData);
        setShowBookInfo(true);
    }

    useEffect(() => {
        getSeries();
        getGenres();
        getAllCurrentBooks();
        if (ISBN) {
            searchBook();
        }
        const handleClickOutside = (event:any) => {
            if (genreRef.current && !genreRef.current.contains(event.target)) {
                setGenreIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        console.log(allBooks, newBook["ISBN13"]);
        const bookInList = allBooks.find((book: { "ISBN13": string }) => book["ISBN13"] === newBook["ISBN13"]);
        if (bookInList?.['Book Id']) {
        navigate(`/Book/${bookInList['Book Id']}`); 
        }
    }, [allBooks, ISBN]);

    useEffect(() => {
        console.log(loading);
        
    }, [loading])
  
    if (loading) {
        return <LoaderFull />
    }


    return (
    <PageLayout
        headerText={`Add Book`}
        type="light"
      >
        <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 mt-[40px]">
         

            <form className="max-w-sm " onSubmit={(e) => {e.preventDefault(); searchBook()}}>
                <div className="mb-5">
                    <label htmlFor="ISBN" className="block mb-2 text-sm font-medium text-gray-900">ISBN number</label>
                    <input 
                        onChange={(e) => setISBN(e.target.value)}
                        type="text" 
                        id="ISBN" 
                        value={ISBN}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" 
                        placeholder="ISBN" 
                        required 
                        // disabled={foundBookInfo}
                    />
                </div>
            <button disabled={showBookInfo} type="submit" className="disabled:text-gray-900/50 disabled:bg-gray-50 disabled:cursor-not-allowed disabled:hover:bg-gray-50 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center ">Search book</button> 
            
            </form>

            {showBookInfo && 
               <form
                onSubmit={(e) => {
                    e.preventDefault();
                    addBook();
                }}
                >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label
                                htmlFor="title"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Title
                            </label>
                            <input
                                value={newBook.Title}
                                onChange={(e) => setNewBook({...newBook, Title: e.target.value})}
                                type="text"
                                id="title"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Title"
                                required
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="id"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                ID
                            </label>
                            <input
                                value={newBook['Book Id']}
                                type="text"
                                id="id"
                                className="disabled:cursor-not-allowed bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="ID"
                                required
                                readOnly
                                disabled
                            />
                        </div>
                    
                
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label
                                htmlFor="author"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Author
                            </label>
                            <input
                                value={newBook['Author']}
                                onChange={(e) => setNewBook({...newBook, Author: e.target.value})}
                                type="text"
                                id="author"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Author"
                                required
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="authorlf"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Author l-f
                            </label>
                            <input
                                value={newBook['Author l-f']}
                                onChange={(e) => setNewBook({...newBook, 'Author l-f': e.target.value})}
                                type="text"
                                id="authorlf"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Author l-f"
                                required
                            />
                        </div>
                    </div>


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label
                                htmlFor="Additional Authors"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Additional Authors
                            </label>
                            <input
                                value={newBook['Additional Authors']}
                                onChange={(e) => setNewBook({...newBook, 'Additional Authors': e.target.value})}
                                type="text"
                                id="Additional Authors"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Additional Authors"

                            />
                        </div>
                        <div>
                            <label
                                htmlFor="Publisher"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Publisher
                            </label>
                            <input
                                value={newBook['Publisher']}
                                onChange={(e) => setNewBook({...newBook, 'Publisher': e.target.value})}
                                type="text"
                                id="Publisher"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Publisher"
                                required
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label
                                htmlFor="Binding"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Binding
                            </label>
                            <input
                                value={newBook['Binding']}
                                type="text"
                                id="Binding"
                                className="disabled:bg-gray-50 disabled:cursor-not-allowed border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Binding"
                                readOnly
                                disabled
                                required
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="Number of Pages"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Number of Pages
                            </label>
                            <input
                                value={newBook['Number of Pages']}
                                onChange={(e) => setNewBook({...newBook, 'Number of Pages': e.target.value})}
                                type="number"
                                id="Number of Pages"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Number of Pages"
                                required
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label
                                htmlFor="averageRating"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Average Rating
                            </label>
                            <input 
                                type='number'
                                step=".01"
                                value={newBook['Average Rating']} 
                                onChange={(e) => setNewBook({...newBook, 'Average Rating': e.target.value})} 
                                id="averageRating"
                                className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Average Rating"
                            />
                        </div>
                        <div>
                            <label className="block mb-2 text-sm font-medium text-gray-900 mt-2">Genres</label>
                            <div className="relative" ref={genreRef}>
                                <div
                                    className="flex items-center border border-gray-300 text-gray-900 bg-[#F9FAFB] text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                    onClick={() => setGenreIsOpen(!genreIsOpen)}
                                >
                                    {newBook['Genres'].length === 0 && (
                                        <span className="text-gray-400">Select genre...</span>
                                    )}
                                    <div className='gap-2 flex'>
                                        {newBook['Genres'].map((genre:any) => (
                                            <span
                                                key={genre}
                                                className="flex items-center bg-[#8784D8] text-white text-sm px-2 py-1 rounded-full"
                                            >
                                                {genres.find((g) => g.genre_id === genre.toString())?.name}
                                                <IconComponent 
                                                    icon={FiX}
                                                    onClick={() => {
                                                        removeGenre(genre);
                                                    }}
                                                    color={'white'}
                                                    className="w-4 h-4 ml-1 cursor-pointer"
                                                />
                                            </span>
                                        ))}
                                    </div>
                                    <IconComponent width={"1em"} icon={FaChevronDown} className="text-gray-500 ml-auto text-xs" />
                                </div>

                                {genreIsOpen && (
                                    <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                                        {genres.map((genre) => (
                                        <li
                                            key={genre.genre_id}
                                            className={`px-4 py-2 cursor-pointer hover:bg-indigo-100 ${
                                            newBook['Genres'].includes(genre.genre_id) ? 'bg-[#8784D8] text-white' : ''
                                            }`}
                                            onClick={() => toggleSelection(genre)}
                                        >
                                            {genre.name}
                                        </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <div>
                            <label
                                htmlFor="Serie"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Serie
                            </label>
                            <select
                                value={newBook['Serie Id']}
                                onChange={(e) => setNewBook({...newBook, 'Serie Id': e.target.value})}
                                id="Serie"
                                className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            >
                                <option value="">Select a serie</option>
                                {series.map((serie) => (
                                    <option key={serie.serie_id} value={serie.serie_id}>
                                        {serie.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label
                                htmlFor="Serie Position"
                                className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                            >
                                Serie Position
                            </label>
                            <input
                                value={
                                    newBook["Serie Position"] === undefined
                                    ? ''
                                    : newBook["Serie Position"]
                                }
                                onChange={(e) => setNewBook({...newBook, 'Serie Position': parseInt(e.target.value) || undefined})}
                                type="number"
                                id="Serie Position"
                                className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Serie Position"
                            />
                        </div>
                </div>
                    
                    <div className="mt-6">
                        <button
                        type="submit"
                        className="disabled:text-gray-900/50 disabled:bg-gray-50 disabled:cursor-not-allowed disabled:hover:bg-gray-50 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                        >
                        Add book
                        </button>
                    </div>
                </form>
            }

        </div>
      </PageLayout>
    );
}

export default AddBook;